import { render, staticRenderFns } from "./ExamAddDialog.vue?vue&type=template&id=48975240&scoped=true"
import script from "./ExamAddDialog.vue?vue&type=script&lang=js"
export * from "./ExamAddDialog.vue?vue&type=script&lang=js"
import style0 from "./ExamAddDialog.vue?vue&type=style&index=0&id=48975240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48975240",
  null
  
)

export default component.exports